export interface QuestionData {
    tag: string;
    is_correct: boolean;
    correct_answer: string;
    submit_answer: string;
    question: string;
    options: string[];
}

export interface AppearedTestDetailsType {
    participant_name: string;
    designation: string;
    quiz_name: string;
    date: string;
    no_of_question: number;
    time_limit: number;
    correct_quiz: number;
    incorrect_quiz: number;
    unattempted_quiz: number;
    total_score: number;
    tags: string[];
    questions: QuestionData[];
}

export const AppearedTestDetails: AppearedTestDetailsType = {
  participant_name: "Rahul Behera",
  designation: "Senior Signal Engineer",
  quiz_name: "Quiz 4",
  date: "12 Sept 2024",
  no_of_question: 20,
  time_limit: 1200,
  correct_quiz: 16,
  incorrect_quiz: 3,
  unattempted_quiz: 1,
  total_score: 16,
  tags: ["All", "Signal", "Track"],
  questions: [
    {
      tag: "Telecom",
      is_correct: true,
      correct_answer: "60 km/h",
      submit_answer: "60 km/h",
      question:
        "What is the maximum permissible speed of a train in a block section with double distant signals during dense fog conditions?",
      options: ["60 km/h", "40 km/h", "30 km/h", "20 km/h"]
    },
    {
      tag: "Track",
      is_correct: false,
      correct_answer: "Stop immediately",
      submit_answer: "Clear track ahead",
      question: "What does a flashing yellow signal indicate to a loco pilot?",
      options: [
        "Caution: Proceed and prepare to stop at the next signal",
        "Clear track ahead",
        "Stop immediately",
        "Proceed at maximum permissible speed"
      ]
    },
    {
      tag: "Signal",
      is_correct: true,
      correct_answer: "All of the above",
      submit_answer: "All of the above",
      question: "Under what circumstances should a train proceed at 15 km/h?",
      options: [
        "Signal failure at a station",
        "During yard movements",
        "Foggy weather without visibility aids",
        "All of the above"
      ]
    },
    {
      tag: "Track",
      is_correct: false,
      correct_answer: "500 mm",
      submit_answer: "400 mm",
      question:
        "What is the standard gap between two consecutive sleepers in Indian railway tracks?",
      options: ["400 mm", "500 mm", "450 mm", "550 mm"]
    },
    {
      tag: "Telecom",
      is_correct: true,
      correct_answer: "Yes",
      submit_answer: "Yes",
      question:
        "Is the train's speed limit automatically reduced during foggy conditions?",
      options: ["Yes", "No"]
    },
    {
      tag: "Track",
      is_correct: true,
      correct_answer: "45 mm",
      submit_answer: "45 mm",
      question: "What is the standard width of the gauge in Indian railways?",
      options: ["45 mm", "52 mm", "60 mm", "75 mm"]
    },
    {
      tag: "Signal",
      is_correct: false,
      correct_answer: "Proceed at reduced speed",
      submit_answer: "Proceed at maximum speed",
      question:
        "What should a loco pilot do when encountering a yellow signal?",
      options: [
        "Proceed at reduced speed",
        "Stop immediately",
        "Proceed at maximum speed",
        "Caution: Prepare to stop"
      ]
    },
    {
      tag: "Telecom",
      is_correct: true,
      correct_answer: "30 km/h",
      submit_answer: "30 km/h",
      question:
        "What is the maximum permissible speed during extreme weather conditions like snow?",
      options: ["30 km/h", "60 km/h", "90 km/h", "120 km/h"]
    },
    {
      tag: "Track",
      is_correct: false,
      correct_answer: "1.5 meters",
      submit_answer: "1 meter",
      question:
        "What is the minimum distance between two trains running on parallel tracks?",
      options: ["1 meter", "1.5 meters", "2 meters", "3 meters"]
    },
    {
      tag: "Signal",
      is_correct: true,
      correct_answer: "Proceed with caution",
      submit_answer: "Proceed with caution",
      question: "What should the driver do when the signal is yellow?",
      options: [
        "Proceed with caution",
        "Stop immediately",
        "Proceed at full speed",
        "Slow down and prepare to stop"
      ]
    }
  ]
};
